const UNDECOMPOSED: Record<string, string> = { ı: "i", ł: "l", ø: "o", đ: "d", ħ: "h", ŧ: "t" };

/** Lowercase without accents, for searching names: "Büşra" and "Busra" both become "busra". */
export const foldText = (text: string): string =>
  text
    .toLowerCase()
    .normalize("NFD")
    .replace(/\p{M}/gu, "")
    .replace(/[ıłøđħŧ]/g, (char) => UNDECOMPOSED[char]);
